import React from "react";
import TSTable from "../common/TSTable";
import { Layout, Modal, theme, Tooltip } from 'antd';
import HeaderScreen from "../common/HeaderScreen";
import * as _ from "lodash";
import { Content } from "antd/es/layout/layout";
import { SECONDARY_COLOR, WHITE_COLOR } from "../constants/color";
import { URL_CHEMICAL } from "../constants/urls";
import { useParams } from "react-router-dom";
import { DELETE, GET } from "../frameworks/HttpClient";
import { toFixed } from "../frameworks/Util";
import ColorButton from "../common/ColorButton";
import {
  DeleteOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import AddPrecursorModal from "../components/chemical/AddPrecursorModal";
import { DATE_FORMAT } from "../constants/string";
import dayjs from 'dayjs';
import ErrorMessages from "../common/ErrorMessages";

export default function PrecursorChemicalScreen() {
  const params = useParams();
  const [transactionData, setTransactionData] = React.useState(null);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [target, setTarget] = React.useState(null);
  const tableRef = React.useRef();

  const fetchTransactionData = async() => {
    setErrorMessages(null);
    try {
      const response = await GET(`${URL_CHEMICAL.QUALITY_CHEMICAL_TANK_TRANSACTION}${params.id}/`)
      setTransactionData(response.data)
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  }

  const {
    token: { colorSuccess, colorError, colorWarning}} = theme.useToken();    

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const confirm = (title, value) => {
    Modal.confirm({
      title: `ลบสารตั้งต้น - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : colorError}} />,
      content: 'คุณต้องการลบสารตั้งต้นใช่หรือไม่ ?',
      okText: 'ใช่',
      cancelText: 'ไม่ใช่',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : colorError}},
      onOk:async() => {
        await handleDeleteMixTransaction(value)
        refreshData();
      },
      onConfirm: () => refreshData()
    });
  };

  const handleDeleteMixTransaction = async(id) => {
    try {
      await DELETE(`${URL_CHEMICAL.CHEMICAL_MIX_TRANSACTION}${id}/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const columns = [
    {
      title : 'Action',
      dataIndex : '',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <Tooltip triger='hover' title="ลบสารตั้งต้น">
              <ColorButton
                type='primary'
                override={colorError}
                icon={<DeleteOutlined />}
                style={{ margin : 5}}
                onClick={()=> confirm(original.pure_chemical_name, original.id)} 
              />
            </Tooltip>
          </div>
      )}
    },
    {
      title : 'วันที่ใช้งาน',
      dataIndex : 'created',
      render : (value) => dayjs(value).format(DATE_FORMAT)
    },
    {
      title : 'ชื่อสารเคมี',
      dataIndex : 'pure_chemical_name',
      searcher: true,
    },
    {
      title : 'Lot No. (สารเคมี)',
      dataIndex : 'lot_no',
    },
    {
      title : 'ปริมาณสารตั้งต้น',
      dataIndex : 'amount',
      render : (value) => toFixed(value, 2)
    },
    {
      title : 'ผู้บันทึก',
      dataIndex : 'created_by_name',
    },
  ]

  React.useEffect(() => {
    fetchTransactionData();
  },[])

  React.useEffect(() => {
    if(transactionData){
      refreshData();
    }
  },[transactionData])

	return(
    <Layout>
      <HeaderScreen title={`สารตั้งต้นในแทงก์เคมีคุณภาพ - ${_.get(transactionData, 'lot_no', "")}`} style={{ backgroundColor : SECONDARY_COLOR, color : WHITE_COLOR, fontSize : 18, fontWeight: 'bolder' }}/>
      <Content
        style={{
          margin: 24,
          minHeight: 280,
          padding: "0px 24px",
      }}>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
        type="primary"
        override={colorSuccess}
        style={{ marginBottom: 10, display: "flex", float: "right" }}
        onClick={() => {
          setTarget("add");
        }}
      >
        + เพิ่มสารตั้งต้น
      </ColorButton>
        <TSTable
          ref={tableRef}
          columns={columns}
          url={transactionData ? URL_CHEMICAL.CHEMICAL_MIX_TRANSACTION : ''}
          size={"small"}
          params={{quality_transaction : _.get(transactionData, 'id', '')}}
        />
      </Content>

      <AddPrecursorModal
        open={target ? true : false}
        onClose={() => {
          setTarget(null);
        }}
        target={target}
        onUpdate={()=> {
          setTarget(null);
          refreshData();
        }}
      />
    </Layout>
)
}